export const baseRadius = {
  rad_2: 2,
  rad_4: 4,
  rad_6: 6,
  rad_8: 8,
  rad_10: 10,
  rad_12: 12,
} as const;

export type RadiusToken = keyof typeof baseRadius;
export type RadiusValue = typeof baseRadius[RadiusToken];
